import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-printables', 'IconBrandPrintables', [
  [
    'path',
    { d: 'M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5z', key: 'svg-0' },
  ],
]);
